<template>
    <el-select :value="value" class="select" clearable filterable :placeholder="$t('shared.pleaseSelectCountry')" :loading="loading" @change="$emit('input', $event)">
        <el-option v-for="item in countries" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from './api'

    export default {
        name: 'country-selector',
        props: ['value'],
        data() {
            return {
                loading: false,
                countries: []
            }
        },
        created() {
            this.loading = true
            api.getCountries().then(countries => {
                this.loading = false
                this.countries = countries
            })
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/countryselector/CountrySelector.vue